import { render } from "./AppSidebar.vue?vue&type=template&id=1bbdb536&scoped=true"
import script from "./AppSidebar.vue?vue&type=script&lang=js"
export * from "./AppSidebar.vue?vue&type=script&lang=js"

import "./AppSidebar.vue?vue&type=style&index=0&id=1bbdb536&lang=sass&scoped=true"
script.render = render
script.__scopeId = "data-v-1bbdb536"

export default script